import PropTypes from 'prop-types';

import SchemaJsonLd from './SchemaJsonLd';

const ItemListJsonLd = ({
  id,
  schemaId = null,
  description,
  items,
  listOrder = 'ascending',
  name,
  renderItemAsSchema,
}) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    ...(schemaId ? { '@id': schemaId } : {}),
    name,
    description,
    itemListOrder: listOrder,
    numberOfItems: items.length,
    itemListElement: items.map(renderItemAsSchema),
  };

  return <SchemaJsonLd id={id} schema={schema} />;
};

ItemListJsonLd.propTypes = {
  id: PropTypes.string.isRequired,
  // Optional JSON-LD `@id` so other schemas (e.g. CollectionPage.mainEntity)
  // can reference this list. Distinct from `id`, which is the DOM id of the
  // <script> tag emitted by SchemaJsonLd.
  schemaId: PropTypes.string,
  description: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  listOrder: PropTypes.string,
  name: PropTypes.string.isRequired,
  renderItemAsSchema: PropTypes.func.isRequired,
};

export default ItemListJsonLd;
